import { axiosUtil as Api } from "../utils/axios";
import CONFIG from "../utils/config";

// const defaultTime = 5000;
const endpoint = CONFIG.VUE_APP_SERVICE_TRANSACTION_PRIVATE
const endpointV2 = CONFIG.VUE_APP_SERVICE_TRANSACTION_PRIVATE_V2

export const TransactionApi = Object.freeze({
    getAll: (
        perPage,
        page,
    ) => Api.get(endpoint + '/transaction?per_page=' + perPage + '&page=' + page + '&is_admin=true'),

    getAllFilter: (
        perPage,
        page,
        search,
        filter,
        start,
        end,
        isHaveTransaction,
        payment_code,
        classrroom,
    ) => {

        const res = Api.get(endpoint + '/transaction?per_page=' + perPage + '&page=' + page + '&search=' + search + '&filter=' + filter + '&start=' + start + '&end=' + end + '&is_admin=true&is_have_transaction=' + isHaveTransaction + '&payment_id=' + payment_code + '&classroom=' + classrroom)
        return Promise.resolve(res)
    },

    verify: (
        id
    ) => Api.put(endpoint + '/transaction/' + id + '/verify'),

    reject: (
        id,
        payload
    ) => Api.put(endpoint + '/transaction/' + id + '/reject', payload),

    detail: (
        id
    ) => Api.get(endpoint + '/transaction/' + id),

    getUserTransaction: (
        uuid
    ) => Api.get(endpoint + '/user/' + uuid + '?per_page=100'),

    exportTransaction: (
        perPage,
        start,
        end,
    ) => Api.get(endpoint + '/transaction?per_page=' + perPage + '&start=' + start + '&end=' + end + '&download=true', { responseType: 'blob' }),

    getSummaryTransaction: () => Api.get(endpointV2 + '/transaction-summary'),

    getAllPaymentMethod: () => Api.get(endpoint + '/payment-method'),
    // paylater
    getAllPaylater: (
        perPage,
        page,
        search,
        uuid
    ) => search ? uuid ? Api.get(endpoint + '/paylater-request?per_page=' + perPage + '&page=' + page + '&search=' + search + '&uuid=' + uuid) : Api.get(endpoint + '/transaction/paylater-request?per_page=' + perPage + '&page=' + page + '&search=' + search) : uuid ? Api.get(endpoint + '/transaction/paylater-request?per_page=' + perPage + '&page=' + page + '&uuid=' + uuid) : Api.get(endpoint + '/transaction/paylater-request?per_page=' + perPage + '&page=' + page),

    detailPaylater: (id) => Api.get(endpoint + '/paylater-request/' + id),

    deletePaylater: (id) => {
        const res = Api.delete(endpoint + '/paylater-request/' + id)

        return Promise.resolve(res)
    },

    paylaterPaymentVerification: (id) => {
        const res = Api.put(endpoint + '/transaction/' + id + '/verify-paylater')

        return Promise.resolve(res)
    },

    getPackageTopup() {
        try {
            const res = Api.get(endpoint + '/package-top-up')
            return Promise.resolve(res)
        } catch (err) {
            return Promise.reject(err)
        }
    },

    getOnePackageTopup(id) {
        try {
            const res = Api.get(endpoint + '/package-top-up/' + id)
            return Promise.resolve(res)
        } catch (err) {
            return Promise.reject(err)
        }
    },

    addPackageTopup(payload) {
        try {
            const res = Api.post(endpoint + '/package-top-up', payload)
            return Promise.resolve(res)
        } catch (err) {
            return Promise.reject(err)
        }
    },

    updatePackageTopup(id, payload) {
        try {
            const res = Api.put(endpoint + '/package-top-up/' + id, payload)
            return Promise.resolve(res)
        } catch (err) {
            return Promise.reject(err)
        }
    },

    deletePackageTopup(id) {
        try {
            const res = Api.delete(endpoint + '/package-top-up/' + id )
            return Promise.resolve(res)
        } catch (err) {
            return Promise.reject(err)
        }
    },

    addPackageTopupV2(payload) {
        try {
            const formData = new FormData
            formData.append('code', payload.code)
            formData.append('name', payload.name)
            formData.append('description', payload.description)
            formData.append('amount', payload.amount)
            formData.append('price', payload.price)
            if (payload.thumbnail) {
                formData.append('thumbnail', payload.thumbnail)
            }
            const res = Api.post(endpointV2 + '/package-top-up', formData)
            return Promise.resolve(res)
        } catch (err) {
            return Promise.reject(err)
        }
    },

    updatePackageTopupV2(id, payload) {
        try {
            const formData = new FormData
            formData.append('code', payload.code)
            formData.append('name', payload.name)
            formData.append('description', payload.description)
            formData.append('amount', payload.amount)
            formData.append('price', payload.price)
            if (payload.thumbnail) {
                formData.append('thumbnail', payload.thumbnail)
            }
            const res = Api.post(endpointV2 + '/package-top-up/' + id, formData)
            return Promise.resolve(res)
        } catch (err) {
            return Promise.reject(err)
        }
    },

    getPriceTopup() {
        try {
            const res = Api.get(endpoint + '/setting/quota-price')
            return Promise.resolve(res)
        } catch (err) {
            return Promise.reject(err)
        }
    },

    updatePriceTopup(payload) {
        try {
            const res = Api.put(endpoint + '/setting/price_top_up', payload)
            return Promise.resolve(res)
        } catch (err) {
            return Promise.reject(err)
        }
    },
});